import React from "react";
import styled from "styled-components";
import {} from "@atlassian/switcher";
import Environment from "../../common/environment";

const DiscoverSection = (props: { variation: string }) => {
  console.log("PROPS", props.variation);

  const variations: any = {
    "expcen-1501_variation_1": {
      name: "Atlas",
      description: "A teamwork directory to stay in sync, async",
      url: `${Environment.getWacIntegrationUrl()}/try/cloud/signup-atlas`
    },
    "expcen-1501_variation_2": {
      name: "Jira Work Management",
      description: "The new home for business teams in Jira",
      url: `${Environment.getWacIntegrationUrl()}/try/cloud/signup-jwm`
    },
  };

  const v = variations[props.variation];

  if (v) {
    return (
      <>
        <Container>
          <Content>
            <Header>Discover</Header>
          </Content>
          <Content>
            <Item>
              <Link href={v.url}>
                <Before>
                  <BeforeWrapper>
                    <BeforeImage src="https://fd-assets.prod.atl-paas.net/image/logos/contrib/jira-software/icons/white.svg"></BeforeImage>
                  </BeforeWrapper>
                </Before>
                <MiddleWrapper>
                  <MiddleContent>
                    {v.name} <RecommendedChip>RECOMMENDED</RecommendedChip>
                  </MiddleContent>

                  <MiddleDescription>{v.description}</MiddleDescription>
                </MiddleWrapper>
              </Link>
            </Item>
          </Content>
        </Container>
      </>
    );
  } else {
    return <></>;
  }
};

const Container = styled.div`
  padding: 8px 0;
`;

const Content = styled.div`
  -webkit-animation: ljGnjM 500ms ease forwards;
  animation: ljGnjM 500ms ease forwards;
  opacity: 0;
`;

const Header = styled.h1`
  font-size: 0.7857142857142857em;
  font-style: inherit;
  line-height: 1.4545454545454546;
  color: var(--ds-text-subtlest, var(--ds-text-subtlest, #6b778c));
  font-weight: 700;
  margin-top: 16px;
  text-transform: uppercase;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
`;

const Item = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;

  &:hover {
    background-color: #e8e9ef;
  }
`;

const Link = styled.a`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  background-color: transparent;
  color: var(--ds-text, #091e42);
  fill: transparent;
  -webkit-text-decoration: none;
  text-decoration: none;
  padding: 7px 8px 7px 8px;
  width: 100%;

  &:hover {
    color: var(--ds-text, #091e42);
    text-decoration: none;
  }
`;

const RecommendedChip = styled.div`
  margin-left: 4px;
  border-radius: 4px;
  padding: 1px 5px;
  background-color: #dde7fe;
  color: #354ba4;
  font-size: 10px;
  font-weight: 500;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.3px;
`;

const Before = styled.div`
  margin-right: 8px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding-bottom: 1px;
`;

const BeforeWrapper = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  box-shadow: var(
    --ds-shadow-raised,
    0 1px 1px rgba(9, 30, 66, 0.25),
    0 0 1px 1px rgba(9, 30, 66, 0.13)
  );
  background-color: #0052cc;
  overflow: hidden;
`;

const BeforeImage = styled.img`
  width: 24px;
  height: 24px;
`;

const MiddleWrapper = styled.span`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0;
  overflow: hidden;
`;

const MiddleContent = styled.span`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.1428571428571428;
  padding-bottom: 1px;
`;

const MiddleDescription = styled.span`
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6b778c;
  font-size: 11px;
  line-height: 1.2727272727272727;
  padding-bottom: 1px;
`;

const After = styled.div`
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding-bottom: 1px;
`;

export default DiscoverSection;
